import type { AssetForm } from '../../forms';
import type { ChannelForm } from '../../forms/Channel/ChannelForm';
import type { LiveProgramForm } from '../../forms/LiveProgram/LiveProgramForm';
import type { StartJobPayloadExtraParams } from './SaveAssetJobsState';

export type JobStatus = 'Pending' | 'InProgress' | 'Completed' | 'Failed';

export class SaveAssetJob {
  index: number = 0;
  isPopupOpen: boolean = true;
  assetForm: AssetForm = null;
  showSubtitleLink: boolean = false;
  channelForm: ChannelForm = null;
  liveProgramForm: LiveProgramForm = null;
  jobType: string = null;
  jobStatus: JobStatus = 'Pending';

  message: string = '';
  progress: number = 0;

  intervalId: number | null = null;
  extraParams?: StartJobPayloadExtraParams;

  constructor(
    form: AssetForm | ChannelForm | LiveProgramForm,
    jobType: string,
    extraParams: StartJobPayloadExtraParams,
    index: number
  ) {
    this.jobType = jobType;
    this.extraParams = extraParams;
    this.index = index;
    if (jobType === 'ChannelThumbnail') {
      this.channelForm = form;
    } else if (jobType === 'LiveProgramThumbnail') {
      this.liveProgramForm = form;
    } else {
      this.assetForm = form;
    }
  }
}
